
export default class Dropdown {

	constructor(node, callback) {
		this.node = node;
		this.callback = callback;
		this.input = node.querySelector('input');
		this.options = node.querySelectorAll('.option');
    	this.addListener();
	}

	addListener() {
		this.toggleDropdown = this.onToggle.bind(this);
		this.selectOption = this.onSelect.bind(this);

		this.node.addEventListener('click', this.toggleDropdown);
		this.options.forEach((option) => {
			option.addEventListener('click', this.selectOption);
		});
	}

	onToggle(e) {
		e.stopPropagation();
		this.node.classList.toggle('opened');
		this.callback && this.callback({
			type: 'toggle',
			current: this.node
		})
	}

	onSelect(e) {
		this.input.value = e.currentTarget.textContent;
		this.callback && this.callback({
			type: 'select',
			current: e.currentTarget.textContent
		})
	}

	destroy() {
		this.node.removeEventListener('click', this.toggleDropdown);
		this.options.forEach((option) => {
			option.removeEventListener('click', this.selectOption);
		});
	}

	static destroyAll() {
		Dropdown.items.forEach((item) => {
			item.destroy();
		});
	}

	static init(context, callback) {
		const node = context ? context : document;
		Dropdown.items = Array.from(node.querySelectorAll('[data-dropdown]')).map(node => {
			new Dropdown(node, callback)
		})
	}
}
